import React from "react";
import NotSubscribedMessageComponent from "./UI/NotSubscribedMessageComponent";

const EUCommunicationRecordClientOrderComponent = () => {
  return (
    <>
      <main className="middle_section dashboard_middle">
        <div className="container">
          <NotSubscribedMessageComponent />
        </div>
      </main>
    </>
  );
};

export default EUCommunicationRecordClientOrderComponent;
